import { ActionTypes } from "../constants";

const reduceSuccessMessage = (state = null, action) => {
    if (action.type.endsWith("_REQUEST")) {
        return null;
    }

    switch (action.type) {
        case ActionTypes.UPDATE_ACCOUNT_PROFILE_SUCCESS:
        case ActionTypes.UPDATE_ACCOUNT_SECURITY_SUCCESS:
        case ActionTypes.UPDATE_ACTIVITY_SUCCESS:
        case ActionTypes.UPDATE_DEVELOPMENT_NEED_SUCCESS:
        case ActionTypes.UPDATE_JP_ACTIVITY_SUCCESS:
        case ActionTypes.UPDATE_MSF_SURVEY_SUCCESS:
        case ActionTypes.UPDATE_NOTE_SUCCESS:
        case ActionTypes.UPDATE_PDP_SUCCESS:
        case ActionTypes.UPDATE_QUALIFICATION_SUCCESS:
        case ActionTypes.UPDATE_RESOURCE_SUCCESS:
        case ActionTypes.UPDATE_RMS_APPRAISAL_SUCCESS:
        case ActionTypes.UPDATE_RMS_APPRAISAL_FORM_SUCCESS:
        case ActionTypes.UPDATE_RMS_APPRAISAL_FORM_ELEMENT_SUCCESS:
        case ActionTypes.UPDATE_SCOPE_OF_WORK_SUCCESS:
        case ActionTypes.UPDATE_TERM_SUCCESS:
            return "Saved";

        case ActionTypes.ADD_RMS_APPRAISAL_INIT_SUCCESS:
        case ActionTypes.SEND_ACCOUNT_PASSWORD_RESET_LINK_SUCCESS:
            return "Request sent";

        case ActionTypes.ADD_ACTIVITY_SUCCESS:
        case ActionTypes.ADD_DEVELOPMENT_NEED_SUCCESS:
        case ActionTypes.ADD_JP_ACTIVITY_SUCCESS:
        case ActionTypes.ADD_MSF_SURVEY_SUCCESS:
        case ActionTypes.ADD_SCOPE_OF_WORK_SUCCESS:
            return "Added";

        case ActionTypes.DELETE_ACTIVITY_SUCCESS:
        case ActionTypes.DELETE_DEVELOPMENT_NEED_SUCCESS:
        case ActionTypes.DELETE_JP_ACTIVITY_SUCCESS:
        case ActionTypes.DELETE_NOTE_SUCCESS:
        case ActionTypes.DELETE_QUALIFICATION_SUCCESS:
        case ActionTypes.DELETE_RESOURCE_SUCCESS:
        case ActionTypes.DELETE_SCOPE_OF_WORK_SUCCESS:
            return "Deleted";

        case ActionTypes.ACTIVATE_APPLICATION:
            return "Activated";

        case ActionTypes.CLEAR_SUCCESS_MESSAGE:
        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceSuccessMessage;
